import Component from 'antd/es/menu';
import 'antd/lib/menu/style';
export default Component;

